import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { PositionTrackerFilters } from './widgets/position-tracker-filters/PositionTrackerFilters'
import { PositionTrackerChart } from './widgets/position-tracker-chart/PositionTrackerChart'
import { PositionTrackerTable } from './widgets/position-tracker-table/PositionTrackerTable'
import { useAppSelector } from '../../app/store/hooks/Redux'
import { selectProject } from './model/positionTrackerSlice'
import { PreparingDataStub } from '../../lib/widgets/stubs/PreparingDataStub'
import { StubLayout } from '../../lib/widgets/stubs/StubLayout'
import clsx from 'clsx'

import styles from './PositionTrackerPage.module.scss'
import { useTranslation } from 'react-i18next'
import { useMenuLayout } from '../../app/layouts/main-layout/hooks/UseMenuLayout'

export const PositionTrackerPage = () => {
  const { t } = useTranslation()
  const { menuLayout } = useMenuLayout()
  const { has_seo_links: hasSeoLinks } = useAppSelector(selectProject)

  return (
    <CommonMainPage
      hint={t('navigation.hint.SEOPositionTracker')}
      title={t('navigation.SEOPositionTracker')}
    >
      <section className={clsx(styles.wrapper, menuLayout === 'top' ? 'gap-[50px]' : 'gap-[24px]')}>
        <PositionTrackerFilters />
        {hasSeoLinks ? (
          <>
            <PositionTrackerChart />
            <PositionTrackerTable />
          </>
        ) : (
          // над заглушкой gap колонки страницы и пустая строка чипов фильтров (8px)
          <StubLayout gap={(menuLayout === 'top' ? 50 : 24) + 8}>
            <PreparingDataStub />
          </StubLayout>
        )}
      </section>
    </CommonMainPage>
  )
}
